import React, { useState, useEffect } from "react";
import "./Announcement.css";
import { fetchAnnouncements } from "../services/api";

const Announcement = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getAnnouncements = async () => {
      try {
        const data = await fetchAnnouncements(0);
        // console.log('Fetched Announcements:', data);
        setAnnouncements(data);
      } catch (error) {
        console.error("Failed to fetch announcements:", error);
        setAnnouncements([]);
      } finally {
        setLoading(false);
      }
    };

    getAnnouncements();
  }, []);

  // If there are no announcements or still loading, don't render the component
  if (loading || announcements.length === 0) {
    return null;
  }

  const combinedAnnouncements = announcements
    .map(
      (announcement) => `${announcement.title}`
    )
    .join("                ");

  return (
    announcements &&
    announcements.length > 0 && (
      <div className="announcement-bar">
        <div className="announcement-content">
          <div className="announcement-scroll">
            {combinedAnnouncements} {combinedAnnouncements}
          </div>
        </div>
      </div>
    )
  );
};

export default Announcement;
